// Campo «Centro de costo» de los editores de lo que se paga a la wallet: texto libre que captura
// finanzas; vacío = el ledger asienta el pago sin asignar.
import type { ComponentPropsWithRef } from 'react';
import {
    COST_CENTER_LABEL,
    COST_CENTER_MAX_LENGTH,
    COST_CENTER_MESSAGES,
} from '@/shared/lib/costCenter/costCenter';
import { FIELD_INPUT } from './EditorForm';
import { EditorField } from './EditorField';

export type CostCenterFieldProps = Omit<ComponentPropsWithRef<'input'>, 'id' | 'type'> & {
    error?: string;
};

/** Acepta lo que devuelve `register` de react-hook-form o `value`/`onChange` controlados. */
export function CostCenterField({ error, className, ...inputProps }: CostCenterFieldProps) {
    return (
        <EditorField
            label={COST_CENTER_LABEL}
            help={COST_CENTER_MESSAGES.help}
            error={error}
            className={className}
        >
            {(id) => (
                <input
                    id={id}
                    type="text"
                    autoComplete="off"
                    spellCheck={false}
                    maxLength={COST_CENTER_MAX_LENGTH}
                    placeholder="Sin asignar"
                    aria-invalid={error ? true : undefined}
                    className={FIELD_INPUT}
                    {...inputProps}
                />
            )}
        </EditorField>
    );
}
